import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { BannerSection, BenefitsSection, CtaSection, HeroSection, PromoSection } from '../sections';
import { LandingVariantProps } from './types';

/** Strips `<0>…</0>` link-placeholder tags, leaving the inner text. */
const stripLinkPlaceholders = (text: string): string => text.replace(/<\/?\d+>/g, '');

/**
 * Variant C — online only: the external registration link promoted to the
 * primary CTA, no phone number. Placeholder layout until the final UX
 * designs arrive; LandingPage guarantees this variant is never rendered when
 * the online link is suppressed for the visitor's locale.
 */
export const LinkOnly: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => (
  <div className="grid grid-cols-12">
    <BannerSection text={copy.banner} />
    <HeroSection number={data.heroNumber} copy={copy.heroCopy} />
    <PromoSection subCopy1={copy.heroSubCopy1} subCopy2={copy.heroSubCopy2} />
    <CtaSection title={copy.registration}>
      {/* onlineCopy may carry a <0>…</0> link placeholder (used by the
          phone+link variant); here the button below is the CTA, so render the
          sentence as plain text with the placeholder tags stripped. */}
      <p className="text-body">{stripLinkPlaceholders(copy.onlineCopy)}</p>
      <div className="w-full md:w-fit">
        <ButtonLink
          href={data.ctaOnlineLink}
          variant="primary"
          id="online-link-cta"
          onClick={() => onCtaClick('online', data.ctaOnlineLink)}
        >
          {copy.ctaOnlineText}
        </ButtonLink>
      </div>
    </CtaSection>
    <BenefitsSection header={data.benefitsHeader} benefits={data.benefits} />
  </div>
);
